import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';

const { FiPhone, FiMail, FiClock, FiStar } = FiIcons;
const { FaWhatsapp, FaFacebook } = FaIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const whatsappUrl = "https://wa.me/447734253236";
  const facebookUrl = "https://www.facebook.com/share/1Am41wyJwq/";

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://i.postimg.cc/Kv8cK38J/A078C18F-42A2-4F90-8BD2-98D500BE7B94.png" 
              alt="Apex Aerials" 
              className="h-12 w-auto mb-4 bg-white p-2 rounded" 
            />
            <p className="text-gray-300 mb-4">
              Professional aerial and satellite services in Manchester for over 60 years. 
              Family-run and highly rated.
            </p>
            <div className="flex items-center gap-2 mb-2">
              <SafeIcon icon={FiStar} className="w-4 h-4 text-yellow-400" />
              <span className="text-sm">1000+ Reviews on Checkatrade</span>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4 border-b border-gray-800 pb-2">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <SafeIcon icon={FaWhatsapp} className="w-5 h-5 text-green-500" />
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="hover:text-green-400 transition-colors">07734253236 (WhatsApp)</a>
              </div>
              <div className="flex items-center gap-3">
                <SafeIcon icon={FaFacebook} className="w-5 h-5 text-blue-500" />
                <a href={facebookUrl} target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors">Facebook Page</a>
              </div>
              <div className="flex items-center gap-3">
                <SafeIcon icon={FiPhone} className="w-5 h-5 text-red-500" />
                <a href="tel:07734253236" className="hover:text-red-400 transition-colors">07734253236 (Mobile)</a>
              </div>
              <div className="flex items-center gap-3">
                <SafeIcon icon={FiPhone} className="w-5 h-5 text-blue-500" />
                <a href="tel:01617945556" className="hover:text-blue-400 transition-colors">0161 794 5556 (Office)</a>
              </div>
              <div className="flex items-center gap-3">
                <SafeIcon icon={FiMail} className="w-5 h-5 text-red-500" />
                <a href="mailto:Apex.Aerials@aol.com" className="hover:text-red-400 transition-colors text-sm break-all">Apex.Aerials@aol.com</a>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4 border-b border-gray-800 pb-2">Our Services</h3>
            <ul className="space-y-2 text-gray-300 text-sm">
              <li>• Aerial Extensions</li>
              <li>• Satellite Installation</li>
              <li>• TV Wall Mounting</li>
              <li>• Equipment Replacement</li>
              <li>• Freesat & Freeview</li>
              <li>• Removal Services</li>
            </ul>
          </div>

          {/* Business Hours */}
          <div>
            <h3 className="text-lg font-bold mb-4 border-b border-gray-800 pb-2">Business Hours</h3>
            <div className="flex items-center gap-2 mb-2">
              <SafeIcon icon={FiClock} className="w-4 h-4 text-red-500" />
              <span>8:00 AM - 9:00 PM</span>
            </div>
            <p className="text-gray-400 text-sm mb-4">7 Days a Week</p>
            <div className="space-y-2 text-xs text-gray-400">
              <p>✓ Free Call Outs</p>
              <p>✓ Same Day Service</p>
              <p>✓ 2 Year Guarantee</p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-10 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © {currentYear} Apex Aerials. Serving Manchester since 1963.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;